import request from '@/utils/contract-axios'

// 获取历史K线
export function fetchContractHistoryKLine(params) {
  return request({
    url: '/quote/kline/history',
    method: 'get',
    params,
  })
}

// 获取持仓数据
export function fetchHoldingData(data) {
  return request({
    url: '/trans/holding/list',
    method: 'post',
    data,
  })
}

// 获取用户资产
export function fetchUserAssets(data) {
  return request({
    url: '/user/asset',
    method: 'post',
    data,
  })
}

// 获取合约标的与币种
export function fetchContractAndCurrency(data) {
  return request({
    url: '/trans/contractAndCurrency',
    method: 'post',
    data,
  })
}

// 开仓市价交易委托
export function doMarketTrade(data) {
  return request({
    url: '/trans/order/market',
    method: 'post',
    data,
  })
}
// 开仓市价交易委托
export function doLimitTrade(data) {
  return request({
    url: '/trans/order/limited',
    method: 'post',
    data,
  })
}

// 获取当前委托列表
export function fetchEntrustList(data) {
  return request({
    url: '/trade/order/list',
    method: 'post',
    data,
  })
}

// 撤销委托单
export function doCancelEntrust(data) {
  return request({
    url: '/trans/order/cancel',
    method: 'post',
    data,
  })
}

// 修改止盈止损
export function doUpdateStopData(data) {
  return request({
    url: '/trans/order/update',
    method: 'post',
    data,
  })
}

// 平仓
export function doClosePosition(data) {
  return request({
    url: '/trans/holding/close',
    method: 'post',
    data,
  })
}

// 一键平仓
export function doOneClickClosePosition(data) {
  return request({
    url: '/trans/holding/batchClose',
    method: 'post',
    data,
  })
}

// 修改止盈止损
export function doUpdateProfitAndLossPrice(data) {
  return request({
    url: '/trans/order/update',
    method: 'post',
    data,
  })
}

// 获取资金历史记录
export function fetchFundHistory(data) {
  return request({
    url: '/account/flow/detail',
    method: 'post',
    data,
  })
}
// 获取成交历史记录
export function fetchDealHistory(data) {
  return request({
    url: '/trans/trading/record',
    method: 'post',
    data,
  })
}
// 获取委托历史记录
export function fetchEntrustHistory(data) {
  return request({
    url: '/trans/entrusted/record',
    method: 'post',
    data,
  })
}
// 获取盈亏历史记录
export function fetchProfitAndLossHistory(data) {
  return request({
    url: '/trans/profitLoss/record',
    method: 'post',
    data,
  })
}
// 获取所有合约行情
export function fetchAllContract(data) {
  return request({
    url: '/ticker/allContract',
    method: 'post',
    data,
  })
}
